<template>
  <div>
    <table class="table">
      <slot />
    </table>
  </div>
</template>
